
const getDefaultState = () => ({
  requestsOverview: {
    loading: false,
    error: false,
    noContent: false,
    items: {},
  },
  requests: {
    loading: false,
    error: false,
    noContent: false,
    items: [],
    channels: [],
    domains: [],
    products: [],
    requestTypes: [],
  },
  filter: {
    search: undefined,
    channel: [],
    requestType: undefined,
    status: [],
    paginationIndex: 1,
    loading: false,
    error: false,
    noContent: false,
    query: undefined,
    loadNewPage: 0,
  },
  requestLogFilesList: {
    request: [],
    items: [],
    loading: false,
    show: 0,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/requestStatus/defaultState.js